import { GenericLabel } from '@com-delta-idp/mnx-utils';
import { Link } from '../../../atoms/link/models/link.interfaces';

export interface ErrorMessage {
  message: Partial<GenericLabel>;
  featureTitle: string;
  action: Link;
  type: ComponentType;
  disable: boolean;
}

export type ComponentType = 'single-error' | 'message-error' | 'full-page';
